import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { COLLECTION_NAMES } from 'src/app/constants/collection.const';
import { Address } from 'src/app/models/address.model';
import { User } from 'src/app/models/user.model';
import { FirestoreService, Params } from '../firebase/firestore.service';

@Injectable({
  providedIn: 'root'
})
export class UserAddressService extends FirestoreService {

  private static isInit = false;
  public mainAddress: BehaviorSubject<Address> = new BehaviorSubject<Address>(null);

  constructor() {
    super();

    this.setCollectionRef(COLLECTION_NAMES.ADDRESS);
  }

  async setup(user: User) {
    if(UserAddressService.isInit) return;
    UserAddressService.isInit = true;

    let mainAddress: Address = null;
    const userAddress = await this.getFeatured(user.uid);
    if(userAddress?.length) {
      mainAddress = userAddress[0];
    }else if(user?.address?.cep) {
      mainAddress = user?.address;
    }
    
    this.mainAddress.next(mainAddress);
  }

  public unsub() {
    this.mainAddress.next(null);
    UserAddressService.isInit = false;
  }

  setSubCollection(id: string) {
    this.setCollectionRef(COLLECTION_NAMES.USER);
    return this.setSubCollectionRefByRef(this.getDocRef(id), COLLECTION_NAMES.ADDRESS);
  }

  addOrUpdateSub(uid: string, address: Address) {
    this.setSubCollection(uid);
    
    return this.addOrUpdate(address);
  }
  
  loadSub(uid: string, params: Params = {}) {
    this.setSubCollection(uid);

    return this.load(params);
  }

  getFeatured(uid: string) {
    const params: Params = {
      where: [{
        key: 'mainAddress',
        condition: '==',
        value: true
      }]
    };

    return this.loadSub(uid, params);
  }

  setMainAddress(uid: string, mainAddress: Address, newMainAddress: Address) {
    const promises = [];
    if(mainAddress?.id) {
      // Desmarca outro endereço como principal
      promises.push(
        this.addOrUpdateSub(uid, {
          id: mainAddress?.id,
          mainAddress: false
        })
      );
    }

    if(newMainAddress?.id) {
      promises.push(
        this.addOrUpdateSub(uid, {
          id: newMainAddress?.id,
          mainAddress: true
        })
      );
    }

    this.mainAddress.next(newMainAddress);
    return Promise.all(promises);
  }

  addressFormatted(address: Address) {
    if(!address || !address?.cep) {
      return "";
    }

    let addressFull = '';

    if(address?.street) {
      addressFull += `${address.street}`;

      if(address?.number) {
        addressFull += `, ${address.number}`;
      }

      if(address?.complement) {
        addressFull += `, ${address.complement}`;
      }

      addressFull += '. ';
    }
    
    if(address?.city) {
      addressFull += ` ${address.city}/${address.state}.`;
    }

    addressFull += ` CEP: ${address.cep}`;

    return addressFull;
  }

}
